import React from "react"
import { Select, MenuItem } from '@mui/material';

export const SortingSelect = ({ value, onChange, options }) => {
    const selectedValue = value || options[0]?.ValueString || '';

    return (
        <Select
                variant="standard"
                size="small"
                value={selectedValue}
                onChange={(event) => onChange(event.target.value)}
                disabled={options.length === 0}
            >
                {options.map((option, key) =>
                    <MenuItem value={option.ValueString} key={key}>{option.Description}</MenuItem>
                )}
        </Select>
    );
}
